var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 6C1.2373 3.01333 3.85472 0.75 7.00005 0.75C10.1454 0.75 12.7622 3.01333 13.3111 6C12.7628 8.98667 10.1454 11.25 7.00005 11.25C3.85472 11.25 1.23788 8.98667 0.688965 6ZM7.00005 8.91667C7.7736 8.91667 8.51546 8.60938 9.06244 8.06239C9.60942 7.51541 9.91672 6.77355 9.91672 6C9.91672 5.22645 9.60942 4.48459 9.06244 3.93761C8.51546 3.39062 7.7736 3.08333 7.00005 3.08333C6.2265 3.08333 5.48463 3.39062 4.93765 3.93761C4.39067 4.48459 4.08338 5.22645 4.08338 6C4.08338 6.77355 4.39067 7.51541 4.93765 8.06239C5.48463 8.60938 6.2265 8.91667 7.00005 8.91667ZM7.00005 7.75C6.53592 7.75 6.0908 7.56563 5.76261 7.23744C5.43442 6.90925 5.25005 6.46413 5.25005 6C5.25005 5.53587 5.43442 5.09075 5.76261 4.76256C6.0908 4.43437 6.53592 4.25 7.00005 4.25C7.46418 4.25 7.9093 4.43437 8.23749 4.76256C8.56567 5.09075 8.75005 5.53587 8.75005 6C8.75005 6.46413 8.56567 6.90925 8.23749 7.23744C7.9093 7.56563 7.46418 7.75 7.00005 7.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentview);
export default __webpack_public_path__ + "static/media/documentview.5e61f6e40f3c36d6af0e071cc7a73531.svg";
export { ForwardRef as ReactComponent };